import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { setHideHeader } from '#src/store/page/actions';

// Same pattern as useHideFooter - lets a page hide the global header
// (rendered by App, above the page's own component tree) without needing
// route-level hideHeader config - resets on unmount (and on the next page
// load, see the page reducer) so it can't leak into whichever page the
// user navigates to next.
export function useHideHeader(hidden = true) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setHideHeader(hidden));
    return () => dispatch(setHideHeader(false));
  }, [dispatch, hidden]);
}
